import React, { useState } from 'react';
import translations from '../../utils/language/translations.json';
import { useTranslation } from 'react-i18next';

const RadioButtonSlider = ({ activeType, setActiveType, leftLabel, rightLabel,t }) => {
  function handleLeftClick() {
    console.log('left clicked');
    setActiveType(leftLabel);
  }
  return (
    <div className="radio-slider">
      <input
        type="radio"
        id="left"
        name="type"
        value={leftLabel}
        checked={activeType === rightLabel}
        onClick={() => handleLeftClick()}
      />
      <label htmlFor="left" className="seller-label">
        {t(`${leftLabel}`)}
      </label>
      <input
        type="radio"
        id="right"
        name="type"
        value={rightLabel}
        checked={activeType === leftLabel}
        onClick={() => setActiveType(rightLabel)}
      />
      <label htmlFor="right" className="buyer-label">
        {t(`${rightLabel}`)}
      </label>
      <div className="slider"><p>{t(`${activeType === rightLabel?rightLabel:leftLabel}`)}</p></div>
    </div>
  );
};
export default RadioButtonSlider;
